const initialState = {
    data: null,
}
export const statsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GETSTATS_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETSTATS_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default statsReducer; 